module.exports = __webpack_public_path__ + "img/hr-train-stop-top-mask.ba099761.png";